<template>
  <div class="wrp">
    <div class="content-box">
      <div class="img-div" @click="invoiceImage.imagePreviewVisible = true">
        <img :src="invoiceImage.src" />
      </div>
      <div @click="invoiceImage.imagePreviewVisible = false">
        <ImagePreview  :visible="invoiceImage.imagePreviewVisible" :img="invoiceImage.src" />
      </div>
      <div class="mock-printer">
      </div>
      <div class="content">
        <div class="scroll-wrp">
          <div class="invoice-header">
            <i class="iconfont">&#xe6ca;</i>
            <p class="invoice-type-text">{{invoiceInfo.invoiceTypeName}}</p>
          </div>
          <img class="invoice-tag" :src="getConfig(invoiceInfo).url" v-if="getConfig(invoiceInfo).url"/>
          <div class="contnt-title">
            <!-- <div class="contnt-title">
              <span :style="{color: '#FF0000'}" v-if="invoiceInfo.ext5 == 1">&nbsp;抬头异常</span>
            </div> -->
          </div>
          <AddValueDetails v-if="(invoiceInfo.invoiceType === '01' || invoiceInfo.invoiceType === '04' || invoiceInfo.invoiceType === '10' || invoiceInfo.invoiceType === '11')"  :invoiceInfo="invoiceInfo" :type="type" :consumerDetails="consumerDetails" />
          <FixedAmount v-if="invoiceInfo.invoiceType === '200'"  :invoiceInfo="invoiceInfo"/>
          <Plane v-if="invoiceInfo.invoiceType === '202'"  :invoiceInfo="invoiceInfo" />
          <Taxi v-if="invoiceInfo.invoiceType === '207'"  :invoiceInfo="invoiceInfo" />
          <Train v-if="invoiceInfo.invoiceType === '201'"  :invoiceInfo="invoiceInfo" />
          <div class="tips">
            <p><i class="iconfont" style="margin-left: 2px; color: #FF7328">&#xe6e2;</i> 特别提示：</p>
            <p>本平台仅提供所查询发票票面信息的查验结果，若发现发票查询结果与实际交易不符，任何单位或个人有权拒收并向当地税务机关举报。</p>
          </div>
        </div>
      </div>

    </div>
    <div class="btn-wrp">
      <van-button
        v-for="(item, index) in btns.slice(0, 2)"
        :key="index"
        class="btn"
        round
        @click="item.handler"
      >
        {{item.name}}
      </van-button>
      <div class="more" v-if="btns.length > 2" @click="changeMoreBtnsVisible">
        更多
        <div class="more-btns-wrp" v-if="showMoreBtns">
          <div v-for="(item, index) in btns.slice(2)"
            :key="index"
            @click="item.handler">
            {{item.name}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Notify, Divider, Dialog, CellGroup, Field, Icon } from 'vant'
import ImagePreview from '@components/ImagePreview'
import { getQuery, ConvertNumber, deepCopy, getConfigWithText } from '@utils/basicUtil'
import moment from 'moment'
import { officialAccountRequest } from '@services'
import { INVOICE_STATUS_ICON } from '@assets/config'
import AddValueDetails from './AddValueDetails'
import FixedAmount from './FixedAmount'
import Plane from './Plane'
import Taxi from './Taxi'
import Train from './Train'

export default {
  data () {
    return {
      consumerDetails: [],
      invoiceImage: {
        imagePreviewVisible: false,
        src: ''
      },
      type: 0,
      id: '',
      invoiceInfo: {},
      showMoreBtns: false,
      btns: []
    }
  },
  computed: {
  },
  mounted () {
    this.getQuery()
    this.getInvoiceDetail()
  },
  methods: {
    getQuery () {
      this.id = getQuery().id
      this.type = Number(getQuery().type)
    },
    moment (data) {
      return moment(Number(data)).format('YYYY-MM-DD')
    },
    back () {
      this.$router.go(-1)
    },
    convertNumber (data) {
      return ConvertNumber(data)
    },
    getInvoiceDetail () {
      if (this.type === 0) {
        this.getNonVat()
      } else {
        this.getVat()
      }
    },
    async getNonVat () {
      const data = await officialAccountRequest.weChat.getNonVat({}, { id: this.id })
      if (data.success) {
        this.invoiceImage.src = data.result.imagePath
        this.invoiceInfo = data.result
        this.editData = deepCopy(data.result)
        this.invoiceInfo.invoiceTypeName = this.invoiceTypeName(data.result.invoiceType)
        this.computedBtnsList(data.result)
      } else {
        Notify({ type: 'danger', message: data.message })
        this.back()
      }
    },
    async getVat () {
      const data = await officialAccountRequest.weChat.getVat({}, { id: this.id })
      if (data.success) {
        this.invoiceImage.src = data.result.weChatVatInvoice.imagePath || data.result.weChatVatInvoice.ocrUrl
        this.invoiceInfo = data.result.weChatVatInvoice
        this.editData = deepCopy(data.result.weChatVatInvoice)
        this.invoiceInfo.invoiceTypeName = this.invoiceTypeName(data.result.weChatVatInvoice.invoiceType)
        this.consumerDetails = data.result.invoiceDetailList || []
        this.computedBtnsList(data.result.weChatVatInvoice)
      } else {
        Notify({ type: 'danger', message: data.message })
        this.back()
      }
    },
    delInvoice () {
      Dialog.confirm({
        title: '提示',
        message: '确认删除该发票数据'
      }).then(() => {
        switch (this.invoiceInfo.invoiceType) {
          case '01':
          case '04':
          case '10':
          case '11':
            this.vatDel()
            break
          case '207':
          case '201':
          case '200':
          case '202':
            this.nonVatDel()
            break
          default:
            break
        }
      })
    },
    async nonVatDel () {
      const data = await officialAccountRequest.weChat.nonVatDel({}, { id: this.invoiceInfo.id })
      if (data.success) {
        Notify({ type: 'success', message: '删除成功' })
        this.back()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    async vatDel () {
      const data = await officialAccountRequest.weChat.vatDel({}, { id: this.invoiceInfo.id })
      if (data.success) {
        Notify({ type: 'success', message: '删除成功' })
        this.back()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    invoiceTypeName (invoiceType) {
      switch (invoiceType) {
        case '01':
          return '增值税专用发票'
        case '04':
          return '增值税普通发票'
        case '10':
          return '增值税电子普通发票'
        case '11':
          return '增值税卷式发票'
        case '202':
          return '机票'
        case '200':
          return '定额发票'
        case '201':
          return '火车票'
        case '207':
          return '出租车发票'
        default:
          break
      }
    },
    getConfig (item) {
      let key = ''
      if (item.checkFlag === 0 && (item.invoiceType === '01' || item.invoiceType === '04' || item.invoiceType === '10' || item.invoiceType === '11')) {
        key = 'invoice-checked-failed' // 验真失败
      }
      if (item.checkFlag === 1) {
        key = 'invoice-checked' // 验真成功
      }
      // if (!item.checkFlag && !(item.invoiceType === '01' || item.invoiceType === '04' || item.invoiceType === '10' || item.invoiceType === '11')) {
      //   key = 'invoice-unchecked' // 未验真
      // }
      if (!key) {
        return ''
      }
      return getConfigWithText(key, INVOICE_STATUS_ICON)
    },
    changeMoreBtnsVisible () {
      this.showMoreBtns = !this.showMoreBtns
    },
    computedBtnsList (data) {
      const arrs = [
        {
          name: '编辑',
          handler: this.goEditPage
        },
        {
          name: '报账',
          handler: this.commit
        },
        {
          name: '删除',
          handler: this.delInvoice
        }
      ]
      if (data.commitFlag === 1) {
      } else if (data.commitFlag === 0) {
        this.btns.push(arrs[0])
        if (data.checkFlag === 1 && (data.invoiceType === '01' || data.invoiceType === '04' || data.invoiceType === '10' || data.invoiceType === '11')) {
          this.btns.push(arrs[1])
        } else if (data.invoiceType === '200' || data.invoiceType === '201' || data.invoiceType === '202' || data.invoiceType === '207') {
          this.btns.push(arrs[1])
          this.btns.push(arrs[2])
        } else {
          this.btns.push(arrs[2])
        }
      } else {
      }
    },
    getInvoiceType (invoiceType) { // 获取发票的类型 1增值税票 0非增值税票
      let type = 0
      switch (invoiceType) {
        case '01':
        case '04':
        case '10':
        case '11':
          type = 1
          break
        case '200':
        case '201':
        case '202':
        case '207':
          type = 0
          break
        default:
          break
      }
      return type
    },
    async commit () {
      let vatIdList = []
      let nonVatIdList = []
      if (this.getInvoiceType(this.invoiceInfo.invoiceType)) { // 增票
        vatIdList.push(this.invoiceInfo.id)
      } else { // 非增票
        nonVatIdList.push(this.invoiceInfo.id)
      }
      const data = await officialAccountRequest.weChat.batchCommit({ vatIdList, nonVatIdList })
      if (data.success) {
        Notify({ type: 'success', message: '提交成功' })
        this.$router.go(0)
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    goEditPage () {
      this.$router.push(`/invoice/income/edit?id=${this.id}&type=${this.type}`)
    }
  },
  components: {
    [Button.name]: Button,
    [Notify.name]: Notify,
    [Divider.name]: Divider,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Icon.name]: Icon,
    ImagePreview,
    AddValueDetails,
    FixedAmount,
    Plane,
    Taxi,
    Train
  }
}
</script>

<style lang="less" scoped src="./style.less" />
